import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import '../../assets/css/styles.css';
import Config from '../../commons/config/Config.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import FormValidation from '../../commons/validation/FormValidation.js';
import Validator from '../../commons/validation/Validator.js';
import Loading from '../ui/Loading.js';
import swal from 'sweetalert';
import { FormattedMessage, injectIntl } from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';
import Notificacion from '../app/Notificacion.js';

// 1. Importa el componente de mantenimiento desde su archivo
import MaintenanceMessage from './MaintenanceMessage'; 

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                usuario: null,
                clave: null
            },
            errors: [],
            loading: false,
            redirectTo: null,
            loginEnabled: ConfigBusiness.get("frontend.loginInstancia.habilitado"),
            loginServices: {},
            azureLoginRedirect: Config.get('apiUrlBase') + '/public/auth/azure/redirect',
            googleLoginRedirect: Config.get('apiUrlBase') + '/public/auth/google/redirect',
            loadingLogoLogin: true,
            logoLoginUrl: null,
            languages: [],
            languagesExtra: {
                "es": props.intl.formatMessage({ id: 'login.languages.español', defaultMessage: 'Español' }),
                "en": props.intl.formatMessage({ id: 'login.languages.ingles', defaultMessage: 'Inglés' })
            }
        };

        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleForgotPassword = this.handleForgotPassword.bind(this);
        this.loginRandom = null;
        this.changeLocale = this.changeLocale.bind(this);

        // 2. Inicializa las propiedades para los intervalos
        this.checkInterval = null;
        this.refreshInterval = null;
    }

    componentWillMount() {
        this.formValidation = new FormValidation({
            component: this,
            validators: {
                'formData.usuario': (value) => Validator.notEmpty(value),
                'formData.clave': (value) => Validator.notEmpty(value)
            }
        });

        fetch(Config.get('apiUrlBase') + '/public/contextos_imagenes/logoLogin', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        }).then(response => {
            let contentType = response.headers.get('Content-Type');
            if (contentType && contentType.startsWith('image/')) {
                return response.blob();
            } else {
                throw new Error('La respuesta no es una imagen, Content-Type: ' + contentType);
            }
        }).then(blob => {
            let fileUrl = URL.createObjectURL(blob);
            this.setState({ logoLoginUrl: fileUrl });
        }).catch((error) => {
            // Silently fail
        }).finally(() => {
            this.setState({ loadingLogoLogin: false });
        });
    }

    componentDidMount() {
        document.body.className = 'vertical-layout vertical-menu 1-column menu-expanded blank-page blank-page';
        document.body.setAttribute('data-col', '1-column');

        // 3. Lógica para activar las verificaciones si el login está deshabilitado
        if (this.state.loginEnabled === "false") {
            // Verificación "interna" cada 5 minutos
            this.checkInterval = setInterval(() => {
                console.log("Verificando si el servicio de login se ha reactivado...");
                // Vuelve a leer la configuración para ver si cambió
                const isEnabled = ConfigBusiness.get("frontend.loginInstancia.habilitado");
                if (isEnabled === "true") {
                    window.location.reload();
                }
            }, 300000); // 300000 ms = 5 minutos

            // Refresco forzado de página cada 15 minutos como fallback
            this.refreshInterval = setInterval(() => {
                window.location.reload();
            }, 900000); // 900000 ms = 15 minutos
        }

        fetch(Config.get('apiUrlBase') + '/public/auth/services', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        }).then(response => {
            if (response.status === 200) {
                response.json().then(data => {
                    this.setState({ loginServices: data });
                });
            } else {
                this.error();
            }
        }).catch((error) => {
            this.error();
        }).finally(() => {
            this.setState({ loading: false });
            // Asegurarse de que 'this.refs.usuario' exista antes de llamar a focus()
            if (this.state.loginEnabled === "true" && this.state.loginServices.classic === 'true' && this.refs.usuario) {
                this.refs.usuario.focus();
            }
        });

        let lang = ConfigBusiness.get("frontend.multilenguaje");
        const langJson = lang ? JSON.parse(lang) : [];
        let langExtra = this.state.languagesExtra;

        if (langJson) {
            this.setState({
                languages: langJson.map(elem => {
                    if (langExtra[elem.lang]) {
                        elem.title = langExtra[elem.lang];
                    }
                    return elem;
                })
            });
        }
    }
    
    // 4. Limpia los intervalos cuando el componente se desmonte para evitar fugas de memoria
    componentWillUnmount() {
        if (this.checkInterval) {
            clearInterval(this.checkInterval);
        }
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    }

    handleFormChange(event) {
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [name]: value
            }
        }));
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({ loading: true, errors: [] });

        fetch(Config.get('apiUrlBase') + '/public/auth/login', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ ...this.state.formData }),
        }).then(response => {
            if (response.status === 200) {
                response.json().then(data => {
                    if (data && data.usuario && data.usuario.token) {
                        localStorage.setItem('persona', JSON.stringify(data));
                        localStorage.setItem('token', data.usuario.token);
                        localStorage.setItem('cerrarNotificacion', "false");
                        if (data.usuario.enable_twofa && ConfigBusiness.get("2fa.habilitado") === "true") {
                            if (!data.celularCodArea || !data.celularNumero) {
                                swal({
                                    title: this.props.intl.formatMessage({ id: 'login.errors.Contacte_al_administrador' }),
                                    text: this.props.intl.formatMessage({ ...(backendStrings['login.errors.No_se_encontro_numero_de_telefono_asociado_a_su_usuario'] || backendStrings['errors.default']) }),
                                    icon: "error",
                                    buttons: { confirm: { text: this.props.intl.formatMessage({ id: 'login.errors.swal.buttons' }), value: true, visible: true, className: "btn btn-primary", closeModal: true } }
                                });
                            } else {
                                this.setState({ redirectTo: '/auth/2fa' });
                            }
                        } else {
                            window.location.reload();
                        }
                    } else {
                        this.error();
                    }
                });
            } else if (response.status === 401) {
                response.json().then(data => { this.setState({ errors: data.detalle }); });
            } else if (response.status === 400) {
                response.json().then(data => {
                    swal({
                        title: this.props.intl.formatMessage({ id: 'login.errors.Contacte_al_administrador' }),
                        text: this.props.intl.formatMessage({ ...(backendStrings[data.detalle[0]] || backendStrings['errors.default']) }),
                        icon: "error",
                        buttons: { confirm: { text: this.props.intl.formatMessage({ id: 'login.errors.swal.buttons' }), value: true, visible: true, className: "btn btn-primary", closeModal: true } }
                    });
                });
            } else {
                this.error();
            }
        }).catch((error) => {
            this.error();
        }).finally(() => {
            this.setState({ loading: false });
        });
    }

    handleForgotPassword(e) {
        e.preventDefault();
        this.setState({ redirectTo: '/olvide-clave' });
    }

    changeLocale(locale) {
        localStorage.setItem('userLocale', locale);
        window.location.reload();
    }

    error() {
        swal({
            title: this.props.intl.formatMessage({ id: 'login.errors.swal.title' }),
            text: this.props.intl.formatMessage({ id: 'login.errors.swal.text' }),
            icon: "error",
            buttons: { confirm: { text: this.props.intl.formatMessage({ id: 'login.errors.swal.buttons' }), value: true, visible: true, className: "btn btn-primary", closeModal: true } }
        });
    }

    render() {
        if (this.formValidation) {
            this.formValidation.validate();
        }
        const validationState = this.formValidation ? this.formValidation.state : null;

        if (!this.loginRandom) {
            this.loginRandom = 1 + Math.floor((4 - 1) * Math.random());
        }

        return (
            <React.Fragment>
                {ConfigBusiness.get("generales.alertaSuspension") === 'true' &&
                    <Notificacion
                        closeable={false}
                        title={this.props.intl.formatMessage({ id: 'layout.Alerta_de_suspension_por_falta_de_pago' })}
                        message={this.props.intl.formatMessage({ id: 'layout.Tu_cuenta_tiene_un_pago_pendiente' })}
                        top="0"
                    />
                }
                {this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
                {this.state.loading && <Loading hideSpinner />}
                <div className="app-content content">
                    <div className="content-wrapper">
                        <div className="content-header row"></div>
                        <div className="content-body">
                            <video className="video-login-bg" autoPlay muted loop poster={`${process.env.PUBLIC_URL}/images/images-login/image${this.loginRandom}.png`}>
                                <source src={`${process.env.PUBLIC_URL}/images/videos-login/video${this.loginRandom}.mp4`} type="video/mp4" />
                                <img src={`${process.env.PUBLIC_URL}/images/images-login/image${this.loginRandom}.png`} alt="Video no soportado" />
                            </video>
                            <section className="flexbox-container">
                                <div className="col-12 d-flex align-items-center justify-content-center">
                                    <div className="col-md-4 col-10 box-shadow-2 p-0">
                                        <div className="card border-grey border-lighten-3 px-2 py-2 m-0">
                                            <div id="loginLogo" className="card-header border-0 text-center" style={{ padding: 0 }}>
                                                <img src={process.env.PUBLIC_URL + "/images/company/logo-login-app.png"} alt="Logo" className="rounded-circle img-fluid center-block" />
                                            </div>
                                            <div className="card-content">
                                                <div className="card-body" style={{ paddingTop: 0 }}>
                                                    {/* 5. Renderizado condicional: Muestra el mensaje de mantenimiento o el formulario de login */}
                                                    {this.state.loginEnabled === "false" ? (
                                                        <MaintenanceMessage />
                                                    ) : (
                                                        <>
                                                            {this.state.loginServices.classic === 'true' &&
                                                                <form className="form-horizontal" noValidate ref="form" onSubmit={this.handleSubmit}>
                                                                    <p id="loginSubtitle" className="card-subtitle line-on-side text-muted text-center font-small-3 mb-2"></p>
                                                                    <fieldset className="form-group position-relative has-icon-left">
                                                                        <input type="text" className="form-control form-control-lg input-lg" id="usuario" name="usuario" ref="usuario" placeholder={this.props.intl.formatMessage({ id: 'login.usuario.placeholder' })} tabIndex="1" required data-validation-required-message={this.props.intl.formatMessage({ id: 'login.usuario.data-validation-required-message' })} aria-invalid="false" onChange={this.handleFormChange} />
                                                                        <div className="form-control-position"><i className="la la-user"></i></div>
                                                                        {validationState && <div className="help-block text-danger font-small-3" hidden={validationState.formData.usuario.pristine || validationState.formData.usuario.valid}>{validationState.formData.usuario.message}</div>}
                                                                    </fieldset>
                                                                    <fieldset className="form-group position-relative has-icon-left">
                                                                        <input type="password" className="form-control form-control-lg input-lg" id="clave" name="clave" placeholder={this.props.intl.formatMessage({ id: 'login.contraseña.placeholder' })} tabIndex="2" required onChange={this.handleFormChange} />
                                                                        <div className="form-control-position"><i className="la la-key"></i></div>
                                                                        {validationState && <div className="help-block text-danger font-small-3" hidden={validationState.formData.clave.pristine || validationState.formData.clave.valid}>{validationState.formData.clave.message}</div>}
                                                                    </fieldset>
                                                                    <div className="form-group row">
                                                                        <div className="col-12 float-sm-left text-center text-sm-right">
                                                                            <button type="button" className="buttonAsLink card-link primary" onClick={this.handleForgotPassword}>
                                                                                <i className="ft-unlock"></i> 
                                                                                <FormattedMessage id="login.contraseña.olvido" />
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <div className="alert alert-danger" role="alert" hidden={this.state.errors.length === 0}>
                                                                        {this.state.errors.map((e, i) => <li key={i}><FormattedMessage {...(backendStrings[e] || backendStrings['errors.default'])} /></li>)}
                                                                    </div>
                                                                    <button type="submit" className="btn btn-outline-primary btn-lg btn-block" disabled={!validationState || !validationState.form.valid}>
                                                                        <i className={this.state.loading ? 'la la-spinner spinner' : 'la la-lock'}></i>
                                                                        <FormattedMessage id="login.ingresar" />
                                                                    </button>
                                                                </form>
                                                            }
                                                            {this.state.loginServices.google === 'true' &&
                                                                <div className="mt-2">
                                                                    <a href={this.state.googleLoginRedirect} className="my-2 text-center">
                                                                        <div className="card d-flex align-items-center" style={{ display: 'flex', flexDirection: 'row', padding: '10px 20px', border: '1px solid #ddd', borderRadius: '8px', backgroundColor: '#f9f9f9', maxWidth: '300px', margin: '10px auto', cursor: 'pointer' }}>
                                                                            <img style={{ width: '40px', height: '40px', marginRight: '5px' }} src={process.env.PUBLIC_URL + "/images/google.svg"} alt="Google" />
                                                                            <span style={{ fontSize: '16px', color: '#333', flex: 1 }}>
                                                                                <FormattedMessage id="login.google" defaultMessage="Sign in with Google" />
                                                                            </span>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            }
                                                            {this.state.loginServices.azure === 'true' &&
                                                                <div className="mt-2">
                                                                    <a href={this.state.azureLoginRedirect} className="my-2 text-center">
                                                                        <div className="card d-flex align-items-center" style={{ display: 'flex', flexDirection: 'row', padding: '10px 20px', border: '1px solid #ddd', borderRadius: '8px', backgroundColor: '#f9f9f9', maxWidth: '300px', margin: '10px auto', cursor: 'pointer' }}>
                                                                            <img style={{ width: '40px', height: '40px', marginRight: '5px' }} src={process.env.PUBLIC_URL + "/images/microsoft.svg"} alt="Microsoft" />
                                                                            <span style={{ fontSize: '16px', color: '#333', flex: 1 }}>
                                                                                <FormattedMessage id="login.microsoft" defaultMessage="Sign in with Microsoft" />
                                                                            </span>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            }
                                                        </>
                                                    )}
                                                    
                                                    <div className="row mt-2">
                                                        <div className="col-6">
                                                            {!this.state.loadingLogoLogin &&
                                                                (this.state.logoLoginUrl ?
                                                                    <img src={this.state.logoLoginUrl} alt="Company Logo" className="img-fluid center-block" /> :
                                                                    <img src={process.env.PUBLIC_URL + "/images/company/logo-login-company.png"} alt="Company Logo" className="img-fluid center-block" />)
                                                            }
                                                        </div>
                                                        <div className="col-6 text-right"><img src={process.env.PUBLIC_URL + "/images/company/logo-login-powered-by.png"} alt="Powered By" className="img-fluid center-block" /></div>
                                                    </div>
                                                    <div className="row">
                                                        <h5 className="login-version">v{process.env.REACT_APP_VERSION}</h5>
                                                    </div>
                                                    <div className="text-center">
                                                        {this.state.languages.map((elem, index, arr) => (
                                                            <React.Fragment key={elem.lang}>
                                                                <span
                                                                    onClick={() => this.changeLocale(elem.lang)}
                                                                    className="cursor-pointer"
                                                                    title={elem.title}>
                                                                    <img className="flag-multilang" src={`${process.env.PUBLIC_URL}/images/flags/${elem.code}.svg`} alt={elem.title} />
                                                                </span>
                                                                {index < arr.length - 1 && <> | </>}
                                                            </React.Fragment>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default injectIntl(Login);
